import { AGGREGATED_ONBOARDING_MODAL_PC_LOADING_HEIGHT_PX } from "./aggregatedOnboardingModalShell";

/**
 * 聚合 ⑥ Loading 布局约定。
 *
 * 涟漪使用 `rippleCentered`（`left/top: 50%` + transform），在 H5 全屏与 PC 480×674 内双轴居中。
 */
export const AGGREGATED_LOADING_LAYOUT_FIGMA = {
  pcModal: "91062:21612",
  pcRipple: "91062:21711",
} as const;

export const AGGREGATED_LOADING_LAYOUT = {
  rippleCentered: true,
  ringPeakOpacity: 0.3,
  pcModalHeightPx: AGGREGATED_ONBOARDING_MODAL_PC_LOADING_HEIGHT_PX,
} as const;
